import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';

export interface ObjectGroupsListItem {
  id: number;
  name: string;
  tiedObjects: number[];
  currentUserAccess?: string[];
}

export const objectGroupsAdapter: EntityAdapter<ObjectGroupsListItem> =
  createEntityAdapter<ObjectGroupsListItem>();

export interface ObjectGroupsState extends EntityState<ObjectGroupsListItem> {
  loading: boolean;
  error?: string;
}

export const initialObjectGroupsState: ObjectGroupsState = objectGroupsAdapter.getInitialState({
  loading: false,
  error: undefined,
});
